/* global google */
export default function (input) {
  return new Promise(function (resolve, reject) {
    const service = new google.maps.places.AutocompleteService()
    const params = {
      input: input,
      types: ['geocode'],
      bounds: null // TODO: get the bounds somehow for better autocomplete suggestions
    }
    service.getPlacePredictions(params, (predictions, status) => {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        resolve(
          predictions.map(p => ({
            name: p.description,
            value: p.place_id
          }))
        )
      } else if (status === google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
        resolve([])
      } else {
        reject(status)
      }
    })
  })
}
